import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { Cycle } from "../models/cycle.model";

export namespace CycleActions {
  @logDispatcher
  export class GetCycles {
    static readonly type = '[Cycle] GetCycles';
    constructor() {}
  }

  @logDispatcher
  export class GetCyclesSuccess {
    static readonly type = '[Cycle] GetCyclesSuccess';
    constructor(public cycles: Cycle[]) {}
  }

  @logDispatcher
  export class GetCyclesFail {
    static readonly type = '[Cycle] GetCyclesFail';
    constructor(public error: any) {}
  }
}
